<template>
  <div class="border-b p-3">
    <Tabs v-model="conversationType" class="flex flex-col gap-3">
      <TabsList class="grid w-full grid-cols-2">
        <TabsTrigger value="direct" class="gap-2">
          <MessageCircle class="h-4 w-4" />
          Direct
        </TabsTrigger>
        <TabsTrigger value="group" class="gap-2">
          <Users class="h-4 w-4" />
          Group
        </TabsTrigger>
      </TabsList>

      <TabsContent value="direct" class="mt-0">
        <DirectConversationSearchPanel :current-user-id="currentUserId" @conversation-create-started="emit('conversationCreateStarted')" @conversation-created="emit('conversationCreated', $event)" @conversation-create-failed="emit('conversationCreateFailed', $event)" />
      </TabsContent>

      <TabsContent value="group" class="mt-0">
        <div class="flex flex-col gap-2">
          <p class="text-xs text-muted-foreground">
            Create a named conversation with multiple participants.
          </p>
          <Button type="button" size="sm" class="w-full gap-2" @click="openGroupConversationModal">
            <Users class="h-4 w-4" />
            Create group
          </Button>
        </div>
      </TabsContent>
    </Tabs>

    <GroupConversationCreateModal ref="groupConversationModal" :current-user-id="currentUserId" @conversation-create-started="emit('conversationCreateStarted')" @conversation-created="handleGroupConversationCreated" @conversation-create-failed="emit('conversationCreateFailed', $event)" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { MessageCircle, Users } from 'lucide-vue-next'
import { Button } from '../../../../../../../resources/js/components/ui/button/index.js'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../../../../../resources/js/components/ui/tabs/index.js'
import DirectConversationSearchPanel from './DirectConversationSearchPanel.vue'
import GroupConversationCreateModal from './GroupConversationCreateModal.vue'

defineProps({
  currentUserId: {
    type: [Number, String, null],
    default: null,
  },
})

const emit = defineEmits(['conversationCreateStarted', 'conversationCreated', 'conversationCreateFailed'])

const router = useRouter()

const conversationType = ref('direct')
const groupConversationModal = ref(null)

const openGroupConversationModal = () => {
  groupConversationModal.value?.openModal()
}

const handleGroupConversationCreated = async (conversation) => {
  if (conversation?.id) {
    await router.push({ name: 'ChatShowPage', params: { conversation: conversation.id } })
  }

  emit('conversationCreated', conversation)
}
</script>
